import {
  colorNameMap,
  eramCpdlcFontNameMap,
  eramFontDimensionMap,
  eramTextDimensionMap,
} from "@poscon/shared-frontend";
export { edstFontDim, edstFontName } from "@poscon/shared-frontend";

export const SPA_INDICATOR = "^";
export const COMPLETED_CHECKMARK_SYMBOL = "\u2713";

// 2 minutes
export const REMOVAL_TIMEOUT = 120e3;

export const cpdlcFont2 = eramCpdlcFontNameMap[2];
export const cpdlcFont2Dimension = eramFontDimensionMap[cpdlcFont2];
export const headerRowHeight = eramTextDimensionMap[2].height * 2 + 2;
export const viewTitleFillColor = colorNameMap.grey.map((c) => c * 0.7);
export const topLeftBorderColor = 0xadadad;
export const bottomRightBorderColor = 0x808080;
export const tableSeparatorColor = 0x252525;
export const postingAreaSeparatorColor = 0xe3cfb4;
export const cyan = 0x11a4a4;
export const alertRed = 0xff0000;
export const mutedAlertRed = 0xa00000;
export const alertYellow = 0xffff00;
export const mutedAlertYellow = 0xa0a000;
export const alertOrange = 0xe48718;
export const defaultTint = 0xf0f0f0;
export const unpairedFpTint = 0x695547;
export const disabledTint = 0x575757;
